export default {
    // 测试
    listButton: '按钮',
    // ment
    HomeOutlined: '我们的使命',
    FreeAdoptionOutlined: '免费领养',
    ShopOutlined: '关于我们',
    FileDoneOutlined: '救助案例',
    GithubOutlined: '宠物知识',
    DollarOutlined: '自助狗狗',
    MessageOutlined: '预约英文课',
};